// react native source for Image and ImageBackground needs proper formatting to work
// remote sources that start with 'http' and base64 encoded sources that start with 'data:' need be wrapped in uri when passing source prop for Image and ImageBackground ie. source={ uri: image }
// local source for image can be passed normally without wrapping in uri ie. source={ image }

/**
 *  example code from react native docs: https://reactnative.dev/docs/imagebackground
 *
 *  const image = {uri: 'https://legacy.reactjs.org/logo-og.png'}
 *
 *  const App = () => (
 *    <View style={styles.container}>
 *      <ImageBackground source={image} resizeMode="cover" style={styles.image}>
 *        <Text style={styles.text}>Inside</Text>
 *      </ImageBackground>
 *    </View>
 *  )
 */

/**
 * Formats the image source for React Native Image and ImageBackground components.
 * @param {string|number} source - The image source, either a URI string or a number (when a local image source is bundled in IOS or Android app).
 * @returns {object|string} - The formatted image source.
 */
const formatImageSource = source => typeof source === 'string' && (source.startsWith('http') || source.startsWith('data:')) ? {
  uri: source
} : source;
export default formatImageSource;